export default "__VITE_ASSET__5ba4c464__"